var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.switchVisualizacao && _vm.selectedType == "porClasseEProduto"
        ? _c("LinhaClasseProduto")
        : _vm._e(),
      _vm.switchVisualizacao && _vm.selectedType == "porClasseEProduto"
        ? _c("LinhaClasseProdutoEvolucao", {
            staticClass: "result-line",
            attrs: {
              monthLabel: _vm.monthLabel,
              timeLabel: _vm.timeLabel,
              indice: _vm.indice
            }
          })
        : _vm._e(),
      !_vm.switchVisualizacao && _vm.selectedType == "porEstrategia"
        ? _c("LinhaEstrategia")
        : _vm._e(),
      _vm.switchVisualizacao && _vm.selectedType == "porEstrategia"
        ? _c("LinhaEstrategiaEvolucao", {
            attrs: {
              monthLabel: _vm.monthLabel,
              timeLabel: _vm.timeLabel,
              indice: _vm.indice
            }
          })
        : _vm._e(),
      _vm.switchVisualizacao ? _c("small", { staticClass: "indice" }) : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }